import { useLocation, useNavigate } from 'react-router-dom';
import ScreenHeader from '../components/ScreenHeader.js';

function formatDate(isoDate) {
    if (!isoDate) return '';
    return new Date(isoDate + 'T00:00:00').toLocaleDateString('en-US', {
        year: 'numeric', month: 'long', day: 'numeric',
    });
}

export default function VisitSubmitted() {
    const { state } = useLocation();
    const navigate = useNavigate();

    const { visitLocation, visitDate, visitors } = state ?? {};

    return (
        <div className="app-wide__container">
            <ScreenHeader message="Visit Plan Submitted" />
            <div className="app-wide__main visit-submitted">
                {state ? (
                    <>
                        <div className="visit-submitted__check">✓</div>
                        <p className="visit-submitted__headline">Your visit plan has been submitted.</p>
                        <div className="visit-submitted__details">
                            <div className="visit-submitted__detail-row">
                                <span className="visit-submitted__detail-label">Site</span>
                                <span className="visit-submitted__detail-value">{visitLocation}</span>
                            </div>
                            <div className="visit-submitted__detail-row">
                                <span className="visit-submitted__detail-label">When</span>
                                <span className="visit-submitted__detail-value">{formatDate(visitDate)}</span>
                            </div>
                            <div className="visit-submitted__detail-row">
                                <span className="visit-submitted__detail-label">People</span>
                                <span className="visit-submitted__detail-value">{visitors.length}</span>
                            </div>
                        </div>
                        <ul className="visit-submitted__list">
                            {visitors.map(v => (
                                <li key={v.id} className="visit-submitted__person">
                                    <span className="visit-submitted__person-name">
                                        {v.visitor_first_name} {v.visitor_last_name}
                                    </span>
                                    <span className="visit-submitted__role-tags">
                                        {v.visitor_is_minor          && <span className="visitor-tag visitor-tag--minor">Minor</span>}
                                        {v.person_is_guardian        && <span className="visitor-tag visitor-tag--guardian">Guardian</span>}
                                        {v.person_will_invite_others && <span className="visitor-tag visitor-tag--inviter">Inviter</span>}
                                        {v.person_is_visitor         && <span className="visitor-tag visitor-tag--visitor">Visitor</span>}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </>
                ) : (
                    <p className="visit-submitted__headline">Your visit plan was submitted.</p>
                )}
            </div>
            <div className="app-wide__footer">
                <div className="formButtons">
                    <button
                        className="button save"
                        onClick={() => navigate('/register-visitor')}
                    >
                        Plan Another Visit
                    </button>
                </div>
            </div>
        </div>
    );
}
